import type { FC, ReactNode } from 'react';

type DnaChoiceTileProps = {
  label: string;
  icon?: ReactNode;
  selected: boolean;
  dimmed?: boolean;
  disabled?: boolean;
  onClick: () => void;
  className?: string;
};

const DnaChoiceTile: FC<DnaChoiceTileProps> = ({
  label,
  icon,
  selected,
  dimmed = false,
  disabled = false,
  onClick,
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={`relative flex min-h-[124px] flex-col items-center justify-center gap-3 rounded-[14px] border px-4 py-5 font-sans text-base transition-[transform,background-color,border-color,color,opacity,box-shadow] duration-500 ease-[cubic-bezier(.22,1,.36,1)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--gold)] ${
        selected
          ? 'border-[var(--gold)] bg-[var(--gold-lt)] text-[var(--ink)] shadow-[0_10px_24px_rgba(201,168,76,0.18)]'
          : 'border-[var(--gold-deep)] bg-[var(--surface)] text-[var(--gold)]'
      } ${dimmed ? 'opacity-55' : 'opacity-100'} disabled:cursor-not-allowed hover:-translate-y-0.5 hover:opacity-100 ${className}`}
    >
      {icon ? <span className="h-8 w-8">{icon}</span> : null}
      <span className="leading-tight">{label}</span>

      {selected ? (
        <span
          className="absolute right-2.5 top-2.5 flex h-6 w-6 items-center justify-center rounded-full bg-[var(--gold)] text-xs font-semibold text-[var(--ink)]"
          aria-hidden="true"
        >
          ✓
        </span>
      ) : null}
    </button>
  );
};

export default DnaChoiceTile;
